export const FAVORITE_ACTION = {
  FAVORITE_PRODUCT: "FAVORITE_ACTION/FAVORITE_PRODUCT",
  UN_FAVORITE_PRODUCT: "FAVORITE_ACTION/UN_FAVORITE_PRODUCT",
  GET_FAVORITE_LIST: "FAVORITE_ACTION/GET_FAVORITE_LIST",
};
